import styled from "styled-components";
import { device } from "../../../../globalStyles/breakpoints";

import { getRetailMatchIndexColor } from "../../../../Util/ColorUtil";
import { lightBorderGray } from "../../../../globalStyles/colors/scoutColors";
import { getBarWidth } from "../../../../Util/RetailMatch/RetailMatchUtil";

interface RetailMatchCarouselImageProps {
  backgroundImage: string;
  selectedImage?: boolean;
}

export const Header = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #000;
  line-height: 35px;
  margin-bottom: 53px;
`;

export const HeaderFocus = styled("div")`
  font-size: 25px;
  font-weight: 800;
  text-align: center;
`;

export const HeaderFocusSharing = styled(HeaderFocus)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const BreakoutContainer = styled("div")`
  display: flex;
  justify-content: space-around;
  color: #000;
  margin: 0 auto 61px;
  max-width: 700px;
  align-items: center;

  ${device.desktop} {
    justify-content: space-between;
  }
`;

export const BreakoutItem = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const BreakoutVerticalBreak = styled.div`
  border-right: 1px solid ${lightBorderGray};
  width: 1px;
  height: 71px;
  margin: 0 7px;
`;

export const BreakoutItemHeader = styled("div")`
  margin-bottom: 8px;
  text-align: center;
`;

export const BreakoutItemVerbiage = styled("div")`
  color: ${(props: { value: number }) => getRetailMatchIndexColor(props.value)};
  text-align: center;
  font-size: 28px;
  margin-bottom: 8px;
  max-width: 195px;
`;

export const BreakoutItemBarOuter = styled("div")`
  height: 8px;
  width: 130px;
  border-radius: 4px;
  background-color: #ededed;
`;

export const BreakoutItemBarInner = styled("div")`
  height: 100%;
  width: ${(props: { value: number }) => getBarWidth(props.value)}%;
  border-radius: inherit;
  background-color: ${(props: { value: number }) =>
        getRetailMatchIndexColor(props.value)};
`;

export const RetailMatchIntroBrandLogoWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 50%;
  height: 176px;
  width: 176px;
`;

interface RetailMatchIntroBrandLogoProps {
  background: string;
}

export const RetailMatchIntroBrandLogo = styled.div`
  background-image: url(${(props: RetailMatchIntroBrandLogoProps) =>
        props.background});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin: 30px auto;
  width: 115px;
  height: 115px;
`;

export const RetailMatchShareIntroBrandLogoWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 50%;
  height: 126px;
  width: 126px;
`;

interface RetailMatchShareIntroBrandLogoProps {
  background: string;
}

export const RetailMatchShareIntroBrandLogo = styled.div`
  background-image: url(${(props: RetailMatchShareIntroBrandLogoProps) =>
        props.background});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin: 20px auto;
  width: 85px;
  height: 85px;
`;

export const RetailMatchIntroBrandingContainer = styled.div`
  width: 100%;
  height: 459px;
  border-radius: 4px;
  background-position: 50 % 50 %;
  background-color: #e7e8ed;
  background-size: cover;
  margin-bottom: 26px;
  border: 1px solid #c4c4c4;
  display: flex;
  flex-direction: column;
  justify-content: space - around;
  align-items: center;
  text-align: center;
  padding: 45px;
  > h3 {
    padding: 0px 32px;
    font-size: 33px;
    line-height: 40px;
    display: inline-block;
    max-width: 487px;
    margin-bottom: 0;
  }

  ${device.desktop} {
    height: 316px;
    padding: 40px 20px 20px;
    > h3 {
      font-size: 20px;
      line-height: 24px;
    }
  }
`;

export const RetailMatchCarouselImage = styled.div`
  height: 99px;
  border-radius: 4px;
  background-image: url(${({
        backgroundImage,
    }: RetailMatchCarouselImageProps) => backgroundImage});
  background-position: 50 % 50 %;
  background-size: cover;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.26);
  opacity: ${({ selectedImage = true }) => (selectedImage ? 1 : 0.3)};

  ${device.desktop} {
    height: 68px;
  }
`;

interface SiteDetailsContainerProps {
  show: boolean;
}

export const SiteDetailsContainer = styled.div`
  display: ${({ show }: SiteDetailsContainerProps) =>
        show ? "block" : "none"};
  margin-bottom: 36px;
  font-size: 15px;
  word-break: break-word;
`;
